import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LocationsService } from '@app/core/services/locations.service';
import { LocationActionTypes } from '@app/core/ngrx';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class LocationsEffects {
  constructor(
    private locationsService: LocationsService,
    private actions$: Actions,
  ) {}

  loadLocations = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActionTypes.LOAD_LOCATIONS),
      switchMap(() => {
        return this.locationsService.getLocations().pipe(
          map(locations => ({
            type: LocationActionTypes.LOAD_LOCATIONS_SUCCESS,
            payload: locations,
          })),
          catchError(err =>
            of({
              type: LocationActionTypes.LOAD_LOCATIONS_ERROR,
              payload: err,
            }),
          ),
        );
      }),
    ),
  );
}
